<script setup>

import { ref, reactive, onMounted, inject, onBeforeUnmount, watch, nextTick, useTemplateRef } from 'vue';
import { onBeforeRouteLeave } from 'vue-router';
import { useStore } from 'vuex';
import { useCommonComposable } from '@/composables/commonComposable.js';
import axios from "axios";

import { useHead } from '@vueuse/head';
import YaDeliveryWidget from "@/components/App/ya-delivery-widget.vue";
useHead({
    title: "Аккаунт — Baller | Оригинальные джерси",
    meta: [
        {name: 'description', content: "Описание страницы"}
    ],
})

const notify = inject('notify');

const { user, getUser } = useCommonComposable();

const store = useStore();

const props = defineProps({
    user: Array,
});

let deliveryServices = ref([])

let input = useTemplateRef('deliveryInput');
let options = useTemplateRef('deliveryOptions');

let addresses = reactive([...store.state.address.userAddresses]);
let isAddNew = ref(false);
let isChange = ref(false);
let addressIdValue = ref(0);

let addressNameValue = ref('');
let countryValue = ref('');
let deliveryServiceValue = ref('Яндекс ПВЗ');
let zipCodeValue = ref('');
let regionValue = ref('');
let cityValue = ref('');
let streetValue = ref('');
let houseNumberValue = ref('');
let apartmentValue = ref('—');
let addressActiveStatus = ref('');
let yaId = ref('');

const closeModal = () => {
    if (!isAddNew.value && !isChange.value) return

    if (event.key === 'Escape' || event.keyCode === 27) {
        event.preventDefault();
        isAddNew.value = false
        isChange.value = false
        resetValues()
    }
}

const validNewAddressValues = () => {
    console.log(addressNameValue.value, deliveryServiceValue.value, cityValue.value, streetValue.value, houseNumberValue.value, apartmentValue.value, countryValue.value, zipCodeValue.value);
    return !(addressNameValue.value === ''
        || deliveryServiceValue.value === ''
        || cityValue.value === ''
        || streetValue.value === ''
        || houseNumberValue.value === ''
        || apartmentValue.value === ''
        || regionValue.value === ''
        || countryValue.value === ''
        || zipCodeValue.value === '');
}

const saveAddress = async () => {
    if (!validNewAddressValues()) {
        notify('Ошибка: пожалуйста, заполните все поля')
        return
    }
    const config = { headers: { 'Cache-Control': 'no-cache' } };
    const data = {
        deliveryAddressId: addressIdValue.value,
        customerId: user.value[0]['ID'],
        addressName: addressNameValue.value,
        deliveryService: 'Яндекс ПВЗ',
        deliveryIndex: zipCodeValue.value,
        country: countryValue.value,
        region: regionValue.value,
        city: cityValue.value,
        street: streetValue.value,
        house: houseNumberValue.value,
        apartment: apartmentValue.value,
        addressStatus: addressActiveStatus.value,
        yaId: yaId.value,
    }

    if (isChange.value && !isAddNew.value) {
        const response = await axios.post(process.env.VUE_APP_API_URL + "/addresses/updateAddress", data, config);

        if (response.status === 200) {
            store.commit('RESET_MODULE', { moduleName: 'address' });
            await store.dispatch(`address/fetchUserAddresses`, {customerId: user.value[0].ID});
            addresses.splice(0, addresses.length);
            addresses.push(...store.state.address.userAddresses);

            notify('Адрес изменен успешно')
            isChange.value = false
        }
    } else if (isAddNew.value && !isChange.value) {
        const response = await axios.post(process.env.VUE_APP_API_URL + "/addresses/addAddress", data, config);

        if (response.status === 200) {
            store.commit('RESET_MODULE', { moduleName: 'address' });
            await store.dispatch(`address/fetchUserAddresses`, {customerId: user.value[0].ID});
            addresses.splice(0, addresses.length);
            addresses.push(...store.state.address.userAddresses);

            notify('Новый адрес добавлен успешно')
            isAddNew.value = false
        }
    }
    resetValues()
}

const updateAddress = async (address) => {
    isChange.value = true;
    addressNameValue.value = address["Имя адреса"]
    countryValue.value = address["Страна"]
    zipCodeValue.value = address["Индекс"]
    cityValue.value = address["Город"]
    regionValue.value = address["Регион"]
    streetValue.value = address["Улица"]
    houseNumberValue.value = address["Дом"]
    apartmentValue.value = address["Квартира"]
    deliveryServiceValue.value = address["Служба доставки"]
    addressIdValue.value = address["ID"]
    addressActiveStatus.value = address["Статус"]
}

const updateYaAddress = async (data) => {
    zipCodeValue.value = data.address.postal_code
    countryValue.value = data.address.country
    cityValue.value = data.address.locality
    regionValue.value = data.address.region
    streetValue.value = data.address.street || '—'
    houseNumberValue.value = data.address.house
    apartmentValue.value = '—'
    deliveryServiceValue.value = 'Яндекс ПВЗ'
    yaId.value = data.id
}

const toggleActiveStatus = (address) => {
    addresses.forEach((item) => {
        item['Статус'] = 'Неактивен';
    });

    const foundAddress = addresses.find((item) => item['ID'] === address['ID']);
    if (foundAddress) {
        foundAddress['Статус'] = 'Активен';
    }

    if (!('serviceWorker' in navigator)) {
        setNewActiveStatus()
    }

    notify('Статус адреса изменен');
    isAddNew.value = false;
};

const setNewActiveStatus = async () => {
    const targetAddress = addresses.find(item => {
        return item['Статус'] === 'Активен'
    })

    if (!targetAddress) return


    const config = { headers: { 'Cache-Control': 'no-cache' } };
    const data = {
        deliveryAddressId: targetAddress['ID'],
        addressStatus: targetAddress['Статус'],
    }
    const response = await axios.post(process.env.VUE_APP_API_URL + "/addresses/updateAddress", data, config);
    if (response.status === 200) {
        store.commit('RESET_MODULE', { moduleName: 'address' });
    }
}

const deleteAddress = async (address) => {
    const baseUrl = process.env.VUE_APP_API_URL + "";
    const response = await axios.post(
        `${baseUrl}/addresses/deleteAddress`,
        {
            customerId: user.value[0]['ID'],
            addressName: address["Имя адреса"],
        },
    );

    if (response.status === 200) {
        store.commit('RESET_MODULE', { moduleName: 'address' });
        await store.dispatch(`address/fetchUserAddresses`, {customerId: user.value[0].ID});
        addresses.splice(0, addresses.length);
        addresses.push(...store.state.address.userAddresses);

        notify(`Адрес ${address["Имя адреса"]} успешно удален`)
    }
}

const resetValues = () => {
    addressIdValue.value = 0
    addressNameValue.value = ''
    deliveryServiceValue.value = 'Яндекс ПВЗ'
    zipCodeValue.value = ''
    countryValue.value = ''
    regionValue.value = ''
    cityValue.value = ''
    streetValue.value = ''
    houseNumberValue.value = ''
    apartmentValue.value = ''
}

const setCoordsOptions = () => {
    if (options.value) {
        options.value.style.top = input.value.getBoundingClientRect().height - 5 + "px"
        options.value.style.width = input.value.getBoundingClientRect().width + "px"
    }
}

onMounted(async () => {
    await getUser();
    await store.dispatch('address/fetchUserAddresses', { customerId: user.value[0].ID });
    addresses.splice(0, addresses.length);
    addresses.push(...store.state.address.userAddresses);

    window.addEventListener('keydown', closeModal);

    window.addEventListener('beforeunload', async function(event) {
        await setNewActiveStatus();
    });

    await nextTick(async () => {
        if ('serviceWorker' in navigator && process.env !== 'production') {
            // await navigator.serviceWorker.register('/assets/js/serviceWorker.js');
        }
    });

    const response = await axios.get(process.env.VUE_APP_API_URL + "/deliveryServices/getDeliveryServices", {})
    if (response.status === 200) {
        deliveryServices.value = response.data;
    }


});

onBeforeUnmount(async () => {
    navigator.serviceWorker.ready.then((registration) => {
        registration.active.postMessage({
            type: 'finalizeChanges',
            changesObj: addresses
        });
    });
    // по идее эта штука должна работать, пока не проверял из-за отсутствия https:// сервера

    window.removeEventListener('keydown', closeModal);
    window.removeEventListener('beforeunload', setNewActiveStatus);
});

onBeforeRouteLeave((to, from, next) => {
    setNewActiveStatus();
    next()
});

watch(async () => isAddNew.value, (newValue, oldValue) => {
    if (isAddNew.value) {
        nextTick(() => {
            setCoordsOptions()
        })
    }
})

watch( () => isChange.value, (newValue, oldValue) => {
    if (isChange.value) {
        nextTick(() => {
            setCoordsOptions()
        })
    }
})

defineExpose({
    toggleActiveStatus,
    setNewActiveStatus,
    addresses,
    resetValues,
    deleteAddress,
    updateAddress,
    saveAddress,
    validNewAddressValues,
    closeModal,
})

</script>

<template>
    <div class="user-addresses">
        <div class="addresses-header">
            <h3 class="page-header">Мои адреса</h3>
            <div class="add-new" @click="isAddNew = true">
                <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M4.28571 5.71429H0V4.28571H4.28571V0H5.71429V4.28571H10V5.71429H5.71429V10H4.28571V5.71429Z" fill="#DC33DF"/>
                </svg>

                <span>Добавить</span>
            </div>
        </div>
        <div class="addresses-block" v-if="addresses.length > 0" v-for="item of addresses">
            <div :class="['address-item-outer', item['Статус'] === 'Активен' ? 'address-active' : 'address-not-active']">
                <div class="header-address-item">
                    <div class="name">
                        <p class="address-name">{{ item["Имя адреса"] }}</p>
                        <p class="address-name" v-if="item['Статус'] === 'Активен'">(Активен)</p>
                        <span class="act" v-else @click="toggleActiveStatus(item)">Выбрать активным</span>
                    </div>
                    <div class="item-actions">
                        <span class="act" @click="updateAddress(item)">Изменить</span>
                        <span>|</span>
                        <span class="act" @click="deleteAddress(item)">Удалить</span>
                    </div>
                </div>
                <div class="address-item-inner">
                    <p>{{ item["Служба доставки"] }}</p>
                    <p v-if="item['Регион'] === item['Город']">{{`${item["Индекс"]}, ${item["Страна"]}, ${item["Город"]}, ${item["Улица"]}, д. ${item["Дом"]} кв. ${item["Квартира"]}`}}</p>
                    <p v-else>{{`${item["Индекс"]}, ${item["Страна"]}, ${item["Регион"]}, ${item["Город"]}, ${item["Улица"]}, д. ${item["Дом"]} кв. ${item["Квартира"]}`}}</p>
                    <p v-if="user[0]">{{ `${user[0]["Имя"]} ${user[0]["Фамилия"]}` }}</p>
                </div>
            </div>
        </div>
        <div v-else class="addresses-block no-addresses">
            <div class="address-item-outer">
                <p>Пока что адресов нет. Добавьте хотя бы один, чтобы мы смогли отправлять заказы</p>
                <div class="btn" @click="isAddNew = true">
                    <div class="add-new">
                        <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M4.28571 5.71429H0V4.28571H4.28571V0H5.71429V4.28571H10V5.71429H5.71429V10H4.28571V5.71429Z" fill="#DC33DF"/>
                        </svg>

                        <span>Добавить</span>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="modal" v-if="isAddNew || isChange">
        <div class="new-address">
            <div class="modal-header">
                <h3 class="page-header">Добавление адреса</h3>
                <span @click="isAddNew = false; isChange = false; resetValues()">[закрыть]</span>
            </div>
            <div class="hr"></div>
            <div class="modal-content">
                <div class="content-row">
                    <div class="input-elem">
                        <span>Название адреса</span>
                        <input v-model="addressNameValue" type="text" name="Address name" id="address-name" placeholder="Любое имя">
                    </div>
                </div>
                <div class="content-row">
                    <div class="input-elem width-40">
                        <span>Страна</span>
                        <input v-model="countryValue" type="text" name="country" id="country" placeholder="">
                    </div>
                    <div class="input-elem width-60">
                        <span>Способ доставки</span>
                        <div class="delivery-service-value">
                            <input ref="deliveryInput" disabled v-model="deliveryServiceValue" type="text" name="delivery-service" id="delivery-service" placeholder="Яндекс ПВЗ">
                            <!-- <div class="options" ref="deliveryOptions">
                                <div class="option-elem" v-for="item of deliveryServices">
                                    {{ item.service }}
                                </div>
                            </div> -->
                        </div>
                    </div>
                </div>
                <div v-if="deliveryServiceValue === 'Яндекс ПВЗ'">
                    <ya-delivery-widget @select="updateYaAddress"></ya-delivery-widget>
                </div>
                <div class="divide" v-if="deliveryServiceValue !== 'Яндекс ПВЗ'">
                    <span>Адрес</span>
                    <div class="hr"></div>
                </div>
                <div class="content-row" v-if="deliveryServiceValue !== 'Яндекс ПВЗ'">
                    <div class="input-elem width-40">
                        <span>Индекс</span>
                        <input v-model="zipCodeValue" type="number" name="zip-code" id="zip-code" placeholder="000000">
                    </div>
                </div>
                <div class="content-row" v-if="deliveryServiceValue !== 'Яндекс ПВЗ'">
                    <div class="input-elem width-50">
                        <span>Регион</span>
                        <input v-model="regionValue" type="text" name="region" id="region" placeholder="Укажите область">
                    </div>
                    <div class="input-elem width-50">
                        <span>Город</span>
                        <input v-model="cityValue" type="text" name="city" id="city" placeholder="Населенный пункт">
                    </div>
                </div>
                <div class="content-row" v-if="deliveryServiceValue !== 'Яндекс ПВЗ'">
                    <div class="input-elem width-60">
                        <span>Улица</span>
                        <input v-model="streetValue" type="text" name="street" id="street" placeholder="">
                    </div>
                    <div class="input-elem width-20">
                        <span>Дом</span>
                        <input v-model="houseNumberValue" type="text" name="house-number" id="house-number" placeholder="">
                    </div>
<!--                    <div class="input-elem width-20">-->
<!--                        <span>Квартира</span>-->
<!--                        <input v-model="apartmentValue" type="number" name="apartment-number" id="apartment-number" placeholder="">-->
<!--                    </div>-->
                </div>
                <div class="divide">
                    <span>Получатель</span>
                    <div class="hr"></div>
                </div>
                <div class="content-row">
                    <div class="input-elem width-50">
                        <input :value="user[0]['Имя']" type="text" disabled>
                    </div>
                    <div class="input-elem width-50">
                        <input :value="user[0]['Фамилия']" type="text" disabled>
                    </div>
                </div>
            </div>
            <div class="hr"></div>
            <div class="btn" @click="saveAddress">
                <span>Сохранить</span>
            </div>
        </div>
    </div>
</template>

<style scoped lang="scss">
@use '~@/assets/styles/vars' as *;

.divide {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    gap: 7px;
    margin-top: 4px;
}

.divide span {
    text-transform: uppercase;
    color: $hard-gray;
    font-size: 10px;
    font-weight: 500;
}

.divide .hr {
    flex-grow: 1;
}

.user-addresses {
    display: flex;
    flex-direction: column;
    gap: 15px
}

.addresses-header {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 30px
}

.addresses-header h3 {
    margin-bottom: 0;
}

.add-new {
    display: flex;
    align-items: center;
    gap: 7%;
    color: $purple;
    text-wrap: nowrap;
    min-width: 30px;

    cursor: pointer;
    transition: $transition;
}

.page-header {
    padding: 0 5px;
}

.add-new span {
    color: $purple;
}

.add-new svg path {
    transition: $transition;
}

.add-new span {
    min-width: inherit;
    font-size: 14px;
    font-weight: 500;
}

.add-new:hover {
    color: $purple-hover;
}

.add-new:hover svg path {
    fill: $purple-hover;
}

.address-item-outer {
    padding: 2% 2.5%;
    box-sizing: border-box;
    background: $white;
    border-radius: 15px;

    display: flex;
    flex-direction: column;
    gap: 10px
}

.address-item-outer .address-name {
    font-size: 14px;
    font-weight: 500;
}

.address-item-inner {
    background: $silver;
    border-radius: 15px;
    padding: 1.1% 1.4%;
    transition: $transition;
    cursor: pointer;
    border: 1px solid $gray;
    box-sizing: border-box;
}

.address-item-inner:hover {
    background: $silver-hover;
}

.address-item-inner p {
    color: $hard-gray;
    font-size: 14px;
    font-weight: 400;
}

.header-address-item {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding: 0 5px;
    box-sizing: border-box;
}

.header-address-item .name {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    gap: 5px
}

.item-actions {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 5px
}

.item-actions span {
    font-size: 12px;
    color: $hard-gray;
    transition: $transition
}

.name .act {
    margin-left: 10px;
    color: $purple
}

.act {
    cursor: pointer;
    font-size: 12px;
    color: $hard-gray;
    transition: $transition
}

.item-actions .act:hover {
    color: $black
}

.btn {
    display: inline-flex;
    border: 1px solid $purple;
    width: fit-content;
    padding: 10px 15px;
    border-radius: 10px;
    box-sizing: border-box;
    transition: $transition;
}

.btn:hover {
    border-color: $purple-hover;
    background: $purple-hover;
}

.btn * {
    transition: $transition;
}

.btn:hover *, .btn:hover path {
    color: $white;
    fill: $white !important;

}

.btn .add-new {
    gap: 10px
}

.no-addresses .address-item-outer {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    gap: 20px
}



.modal {
    position: fixed;
    margin: auto 0;
    z-index: 3;
    height: 100%;
    width: 100%;
    left: 0;
    top: 0;
    backdrop-filter: blur(5px);
    padding: 5% 0;
}

.new-address {
    width: 70%;
    margin: auto auto;
    box-shadow: $shadow;
    background: $white;
    height: 80%;
    border-radius: 15px;
    padding: 2%;
    box-sizing: border-box;

    display: flex;
    flex-direction: column;
    gap: 15px
}

.modal-header {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
}

.modal-header h3 {
    margin-bottom: 0;
}

.modal-header span {
    font-weight: 400;
    font-size: 12px;
    cursor: pointer;
}

.modal-content {
    flex-grow: 1;
    overflow-y: auto;

    display: flex;
    flex-direction: column;
    gap: 10px
}

.modal .btn span {
    color: $purple
}

.modal .btn:hover span {
    color: $white
}

.content-row {
    display: flex;
    flex-direction: row;
    align-items: center;
    flex-shrink: 1;
    gap: 20px;
}

.modal .input-elem {
    display: flex;
    align-items: center;
    gap: 15px;
    box-sizing: border-box;

    flex-shrink: 1;
}

.input-elem span {
    font-size: 14px;
    white-space: nowrap;
}

.input-elem input {
    width: auto;
    min-width: 0;
    box-sizing: border-box;
    flex-grow: 1;
}

.content-row > * { /* Применяется ко всем прямым потомкам content-row */
    min-width: 0; /* Позволяет сжимать элементы */
    flex-shrink: 1; /* Элементы будут уменьшаться пропорционально друг другу */
    box-sizing: border-box; /* Включаем padding и border в ширину элемента */
}

.input-elem.width-30 {
    width: 30%;
}

.input-elem.width-40 {
    width: 40%;
}

.input-elem.width-50 {
    width: 50%;
}

.input-elem.width-60 {
    width: 60%;
}

.input-elem.width-70 {
    width: 70%;
}

.address-active {
    border: 1px solid $purple;
}

.delivery-service-value {
    position: relative;
    flex-shrink: 1;

    width: auto;
    min-width: 0;
    box-sizing: border-box;
    flex-grow: 1;

    display: flex;
}

.delivery-service-value .options {
    position: absolute;
    left: 0;

    width: 100%;
    background: $white;
    box-shadow: $shadow;

    font-size: 12px;
    box-sizing: border-box;
    border: 1px solid $gray;
    border-radius: 7px;
}

.delivery-service-value .options .option-elem:first-child {
    padding-top: 7px;
}

.delivery-service-value .options .option-elem {
    padding: 7px;
    padding-top: 0;
    box-sizing: border-box;
}

@media screen and (max-width: 750px) {
    .addresses-header {
        gap: 15px
    }

    .add-new span {
        font-size: 12px;
    }

    .address-item-outer {
        padding: 12px;
    }

    .address-item-inner {
        padding: 8px 10px;
        border-radius: 10px;
    }

    .address-item-outer .address-name {
        font-size: 12px;
    }

    .address-item-inner p {
        font-size: 12px;
    }

    .item-actions span, .act {
        font-size: 10px;
    }

    .name .act {
        margin-left: 0;
    }

    .header-address-item .name {
        flex-direction: column;
        align-items: flex-start;
    }

    .new-address {
        width: 90%;
        padding: 5%;
        height: 70%;
    }

    .settings-block .modal {
        display: flex;
        flex-direction: column;
        justify-content: center;
        padding-bottom: 65px;
        box-sizing: border-box;
    }

    .modal .input-elem {
        gap: 8px;
    }

    .content-row {
        gap: 12px
    }

    .input-elem > * {
        font-size: 12px !important;
    }

    .modal .btn span {
        font-size: 14px;
    }
}
</style>